import React from 'react';

import { QuantitySelector, IBasicStyledProps, TextAlign } from '@notino/react-styleguide-v20';

import { IBasicProductQuantity } from '@model';
import { ReactFCV } from '@types';
import { fromNumberToArray } from '@utils/math';

import { StyledDisabledText, StyledText, StyledQuantityWrapper } from './styled';

interface DropDownQuantitySelectorProps extends IBasicStyledProps, IBasicProductQuantity {
  maximumQuantity?: number;
  onOptionSelect?: (quantity: number) => void;
  disabled?: boolean;
}

export const DropDownQuantitySelector: ReactFCV<DropDownQuantitySelectorProps> = ({
  maximumQuantity = 0,
  unit,
  onOptionSelect,
  currentQuantity,
  disabled = false,
  ...rest
}) => {
  const options = fromNumberToArray(maximumQuantity);
  return (
    <StyledQuantityWrapper {...rest}>
      {disabled ? (
        <StyledDisabledText>
          <StyledText>{`${currentQuantity} ${unit ?? ''}`}</StyledText>
        </StyledDisabledText>
      ) : (
        <QuantitySelector
          data-testid="quantity-selector"
          options={options}
          unit={unit}
          handleOptionSelect={onOptionSelect}
          currentOption={currentQuantity}
          textAlign={TextAlign.right}
          keyNavigationConfig={{
            keyNavigation: true,
            findOptionByNumberKeys: true,
            selectOptionByNumbersWhenClosed: true,
          }}
        />
      )}
    </StyledQuantityWrapper>
  );
};
